import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { 
  Container, Typography, Table, TableBody, TableCell, 
  TableContainer, TableHead, TableRow, Paper, Button, 
  Chip, Box, CircularProgress, Grid, TextField, MenuItem,
  Autocomplete, Card, Fade, Avatar, Alert, Pagination, CardContent,
  Stack,
  RadioGroup,
  FormControlLabel,
  Radio,
  Checkbox,
} from '@mui/material';
import MedicalInformationIcon from '@mui/icons-material/MedicalInformation';
import SaveIcon from '@mui/icons-material/Save';
import SearchIcon from '@mui/icons-material/Search';
import api from '../services/api';
import { listaExamesDisponiveis } from '../constants/exames';
import { useAuth } from '../AuthContext';
import { toast } from 'react-toastify';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import dayjs from 'dayjs';
import 'dayjs/locale/pt-br';


const ProntuarioPage = () => {
  const {
    user,
    userOngId,
    userEmail,
    podeEditarProntuario,
    apenasLeituraProntuario,
    isVeterinario,
    isSupervisor,
    isAdmin,
  } = useAuth();
  
  const [pets, setPets] = useState([]);
  const [ongs, setOngs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [petSelecionado, setPetSelecionado] = useState(null);
  const [historico, setHistorico] = useState([]);
  const [salvando, setSalvando] = useState(false);
  const [filtroNome, setFiltroNome] = useState("");
  const [filtroTipoTimeline, setFiltroTipoTimeline] = useState('');
  const [filtroMesAnoTimeline, setFiltroMesAnoTimeline] = useState('');
  const [pagina, setPagina] = useState(1);
  const itensPorPagina = 5;
  const [openDatePicker, setOpenDatePicker] = useState(false);
  const timelineRef = React.useRef(null);

  const listaVacinasDisponiveis = ["V8", "V10", "V11", "Antirrábica", "Gripe", "Giárdia", "V5 (Felina)"];

  const [novoAtendimento, setNovoAtendimento] = useState({
  tipoAtendimento: '',
  descricao: '',
  prescricao: '',
  examesSelecionados: [],
  vacinasAplicadas: [],
  tomouVacina: 'nao' ,
  peso:''
});

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

  const LIMITE_DESCRICAO = 1500;
  const LIMITE_PRESCRICAO = 1500;

  const formatarPesoInput = (valor) => {
    const limpo = valor.replace(/[^\d.]/g, '');
    const partes = limpo.split('.');
    const inteiroBruto = partes[0] || '';
    const decimalBruto = partes.slice(1).join('');
    const inteiro = inteiroBruto.replace(/^0+(?=\d)/, '') || (limpo.includes('.') ? '0' : inteiroBruto);

    if (limpo.includes('.')) {
      return `${inteiro || '0'}.${decimalBruto.slice(0, 2)}`;
    }

    return inteiro.slice(0, 4);
  };

  const formatarPesoFinal = (valor) => {
    const normalizado = valor.trim();
    if (!normalizado) return '';

    const numero = Number(normalizado);
    if (Number.isNaN(numero)) return '';

    return numero.toFixed(2);
  };

  const formatarTelefone = (valor) => {
    if (!valor) return '';

    const apenasDigitos = String(valor).replace(/\D/g, '');
    if (apenasDigitos.length <= 10) {
      return apenasDigitos.replace(/^(\d{2})(\d{4})(\d{0,4}).*/, '($1) $2-$3').trim();
    }
    return apenasDigitos.replace(/^(\d{2})(\d{5})(\d{0,4}).*/, '($1) $2-$3').trim();
  };

  const imprimirHtml = (conteudo) => {
    const iframe = document.createElement('iframe');
    iframe.style.position = 'fixed';
    iframe.style.right = '0';
    iframe.style.bottom = '0';
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.style.border = '0';
    iframe.srcdoc = conteudo;
    document.body.appendChild(iframe);

    const limparIframe = () => {
      if (iframe.parentNode) {
        iframe.parentNode.removeChild(iframe);
      }
    };

    iframe.onload = () => {
      try {
        iframe.contentWindow?.focus();
        iframe.contentWindow?.print();
        toast.info('Preparando impressao...');
      } catch (error) {
        toast.error('Nao foi possivel iniciar a impressao.');
      } finally {
        window.setTimeout(limparIframe, 1000);
      }
    };
  };


  const campoPreenchidoSx = (estaPreenchido) => ({
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: estaPreenchido ? '#2e7d32' : undefined,
      },
      '&:hover fieldset': {
        borderColor: estaPreenchido ? '#2e7d32' : undefined,
      },
      '&.Mui-focused fieldset': {
        borderColor: '#2e7d32',
      },
    },
    '& .MuiFormLabel-root.Mui-focused': {
      color: '#2e7d32',
    },
  });

  const formObrigatorioPreenchido =
    novoAtendimento.tipoAtendimento.trim() !== '' &&
    novoAtendimento.peso.trim() !== '' &&
    novoAtendimento.descricao.trim() !== '' &&
    (novoAtendimento.tipoAtendimento !== 'Vacinação' || novoAtendimento.vacinasAplicadas.length > 0);

  const obterCargoResponsavel = useCallback(() => {
    if (isVeterinario) return `Veterinário(a): ${user?.nome}`;
    if (isSupervisor) return `Supervisor(a): ${user?.nome}`;
    return user?.nome;
  }, [isVeterinario, isSupervisor, user?.nome]);

  const obterEmailSolicitante = useCallback((pet) => {
    // Se NÃO for admin, envia o próprio e-mail (regra restrita de ONG/Protetor)
    if (!isAdmin) {
      return String(userEmail || "").trim();
    }

    // Se FOR ADMIN, precisamos do e-mail de quem "é dono" do prontuário do pet
    const ongId = pet?.ongId || pet?.ong?.id || pet?.ong_id;
    const ongDoPet = ongId
      ? (ongs || []).find((ong) => String(ong.id) === String(ongId))
      : pet?.ong;

    const emailOng = String(ongDoPet?.email || "").trim();
    const emailProtetor = String(pet?.protetor?.email || "").trim();
    const emailUsuario = String(pet?.usuario?.email || pet?.usuarioEmail || "").trim();
    
    // Fallback: Se o pet for novo ou não tiver dados, o Admin usa o próprio e-mail
    const emailAdmin = String(userEmail || "").trim();

    // Ordem de prioridade para o Admin conseguir visualizar:
    return emailOng || emailProtetor || emailUsuario || emailAdmin;
  }, [isAdmin, ongs, userEmail]);

  const fetchPets = useCallback(async () => {
    if (!user) return;

    try {
      setLoading(true);
      const ongId = String(userOngId || "").trim();
      const usuarioId = String(user?.id || "").trim();
      const perfil = String(user?.perfil || "").trim();
      const solicitanteEmail = String(user?.email || "").trim();

      let endpoint = "/pets";
      if (!isAdmin) {
        const query = new URLSearchParams({
          ...(ongId ? { ongId } : {}),
          ...(usuarioId ? { usuarioId } : {}),
          ...(perfil ? { perfil } : {}),
          ...(solicitanteEmail ? { solicitanteEmail } : {}),
        });
        const queryString = query.toString();
        endpoint = queryString ? `/pets?${queryString}` : "/pets";
      }

      const response = await api.get(endpoint);
      setPets(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      toast.error("Erro ao carregar pets.");
    } finally {
      setLoading(false);
    }
  }, [isAdmin, user, userOngId]);

  const fetchHistorico = useCallback(async (pet) => {
    const petId = pet?.id;
    if (!petId) return;

    try {
      const emailParam = obterEmailSolicitante(pet);
        if (!isAdmin && !isSupervisor && !emailParam) {
        setHistorico([]);
        toast.warning("Não foi possível identificar o solicitante.");
        return;
      }

     const query = `?emailSolicitante=${encodeURIComponent(emailParam)}`;
    const response = await api.get(`/prontuarios/pet/${petId}${query}`);
    setHistorico(response.data);
  } catch (error) {
    console.error("Erro ao buscar histórico:", error);
    setHistorico([]); // Limpa para não mostrar lixo de outro pet
  }
}, [obterEmailSolicitante, isAdmin, isSupervisor]);

  const fetchOngs = useCallback(async () => {
    try {
      const response = await api.get('/ongs');
      setOngs(response?.data || []);
    } catch (error) {
      console.error('Erro ao buscar ONGs:', error);
      setOngs([]);
    }
  }, []);

  useEffect(() => { if (user) fetchPets(); }, [user, fetchPets]);
  useEffect(() => { if (user) fetchOngs(); }, [user, fetchOngs]);
  useEffect(() => { if (petSelecionado) fetchHistorico(petSelecionado); }, [petSelecionado, fetchHistorico]);
  useEffect(() => {
    setFiltroTipoTimeline('');
    setFiltroMesAnoTimeline('');
    setNovoAtendimento({ tipoAtendimento: '', descricao: '', prescricao: '', examesSelecionados: [], vacinasAplicadas: [], tomouVacina: 'nao', peso: '' });
  }, [petSelecionado?.id]);

  const petsOrdenados = useMemo(() => {
    const lista = Array.isArray(pets) ? [...pets] : [];
    lista.sort((a, b) => {
      const dataA = new Date(a?.criadoEm || a?.createdAt || 0).getTime();
      const dataB = new Date(b?.criadoEm || b?.createdAt || 0).getTime();
      if (dataA !== dataB) return dataB - dataA;
      return (b?.id || 0) - (a?.id || 0);
    });
    return lista;
  }, [pets]);

  const petsFiltrados = useMemo(() => {
    return petsOrdenados.filter((pet) => (pet.nome || "").toLowerCase().includes(filtroNome.toLowerCase()));
  }, [petsOrdenados, filtroNome]);

  const totalPaginas = Math.ceil(petsFiltrados.length / itensPorPagina);
  const petsExibidos = useMemo(() => {
    const inicio = (pagina - 1) * itensPorPagina;
    return petsFiltrados.slice(inicio, inicio + itensPorPagina);
  }, [petsFiltrados, pagina]);


const historicoFiltrado = useMemo(() => {
    if (!historico) return [];
    return historico.filter((item) => {
      const tipoBanco = item?.tipoAtendimento || item?.tipo_atendimento || "";
      const bateTipo = !filtroTipoTimeline || tipoBanco.includes(filtroTipoTimeline);
      
      const dataAtend = item?.dataAtendimento || item?.data_atendimento;
      const data = new Date(dataAtend);
      const mesAnoItem = `${data.getFullYear()}-${String(data.getMonth() + 1).padStart(2, '0')}`;
      const bateMesAno = !filtroMesAnoTimeline || mesAnoItem === filtroMesAnoTimeline;

      return bateTipo && bateMesAno;
    });
  }, [historico, filtroTipoTimeline, filtroMesAnoTimeline]);

  const paraSimNaoLabel = useCallback((valor) => {
    if (valor === null || valor === undefined || valor === '') return null;
    if (typeof valor === 'boolean') return valor ? 'Sim' : 'Não';

    const valorNormalizado = String(valor).trim().toLowerCase();
    if (['sim', 'true', '1', 'yes'].includes(valorNormalizado)) return 'Sim';
    if (['nao', 'não', 'false', '0', 'no'].includes(valorNormalizado)) return 'Não';

    return String(valor);
  }, []);

  const dataUltimoAtendimento = useMemo(() => {
    if (!Array.isArray(historico) || historico.length === 0) return null;

    const datasValidas = historico
      .map((item) => new Date(item?.dataAtendimento))
      .filter((data) => !Number.isNaN(data.getTime()));

    if (datasValidas.length === 0) return null;

    const dataMaisRecente = new Date(Math.max(...datasValidas.map((data) => data.getTime())));
    return dataMaisRecente.toLocaleDateString('pt-BR');
  }, [historico]);

      
    const totalPetsGeral = useMemo(() => petsFiltrados.length, [petsFiltrados]);

    const totalEmQuarentena = useMemo(() => {
      return petsFiltrados.filter((pet) => {
        const statusNormalizado = String(pet?.status || 'ACOLHIDO').toUpperCase();
        return statusNormalizado === 'ACOLHIDO' || statusNormalizado === 'QUARENTENA';
      }).length;
    }, [petsFiltrados]);

    const totalLiberados = useMemo(() => {
      return petsFiltrados.filter((pet) => {
        const statusNormalizado = String(pet?.status || '').toUpperCase();
        return statusNormalizado === 'DISPONIVEL_ADOCAO' || statusNormalizado === 'LIBERADO';
      }).length;
    }, [petsFiltrados]);

  const detalhesCardPet = useMemo(() => {
    const detalhes = [
      { label: 'Sexo', valor: petSelecionado?.sexo || null },
      { label: 'Castrado', valor: paraSimNaoLabel(petSelecionado?.castrado) },
      { label: 'Microchipado', valor: paraSimNaoLabel(petSelecionado?.microchipado) },
      { label: 'Último atendimento', valor: dataUltimoAtendimento },
    ];

    return detalhes.filter((item) => item.valor !== null && item.valor !== undefined && String(item.valor).trim() !== '');
  }, [petSelecionado, paraSimNaoLabel, dataUltimoAtendimento]);

  const detalhesCardPetPrincipais = useMemo(
    () => detalhesCardPet.filter((item) => item.label !== 'Último atendimento'),
    [detalhesCardPet]
  );

  const detalheUltimoAtendimento = useMemo(
    () => detalhesCardPet.find((item) => item.label === 'Último atendimento') || null,
    [detalhesCardPet]
  );

 const handleSalvarAtendimento = async (e) => {
    e.preventDefault();

    let tituloFinal = novoAtendimento.tipoAtendimento;
    const tiposComVacinaOpcional = ['Consulta geral', 'Vermifugação', 'Exame clínico'];
    
    if (tiposComVacinaOpcional.includes(novoAtendimento.tipoAtendimento) && novoAtendimento.tomouVacina === 'sim') {
      tituloFinal = `${novoAtendimento.tipoAtendimento} + Vacina(s)`;
    }

    if (!formObrigatorioPreenchido) {
      toast.warning("Preencha todos os campos obrigatórios.");
      return;
    }

    const pesoFormatado = formatarPesoFinal(novoAtendimento.peso);
    if (!pesoFormatado) {
      toast.warning("Informe um peso válido.");
      return;
    }

    const houveVacina = novoAtendimento.tipoAtendimento === 'Vacinação' || novoAtendimento.tomouVacina === 'sim';
    if (houveVacina && novoAtendimento.vacinasAplicadas.length === 0) {
      toast.warning("Por favor, selecione pelo menos uma vacina.");
      return;
    }

    setSalvando(true);
    try {
      const descricaoComPeso = `Peso: ${pesoFormatado} kg\nDescrição: ${novoAtendimento.descricao}`;
      const descFinal = novoAtendimento.vacinasAplicadas.length > 0 
        ? `${descricaoComPeso}\n\nVacinas: ${novoAtendimento.vacinasAplicadas.join(', ')}`
        : descricaoComPeso;

      const payload = { 
        tipoAtendimento: tituloFinal,
        descricao: descFinal,
        prescricao: novoAtendimento.prescricao,
        peso: novoAtendimento.peso,
        veterinarioResponsavel: obterCargoResponsavel(),
        pet: { id: petSelecionado.id },
        dataAtendimento: new Date().toISOString().split('.')[0] 
      };

      const emailParam = obterEmailSolicitante(petSelecionado);
      const query = emailParam ? `?emailSolicitante=${encodeURIComponent(emailParam)}` : "";
      await api.post(`/prontuarios${query}`, payload);
      
      toast.success("Atendimento registrado com sucesso! 🐾");
      setNovoAtendimento({ tipoAtendimento: '', descricao: '', prescricao: '', examesSelecionados: [], vacinasAplicadas: [], tomouVacina: 'nao', peso: '' });
      fetchHistorico(petSelecionado);
    } catch (error) { 
      toast.error("Erro ao salvar atendimento."); 
    } finally { 
      setSalvando(false); 
    }
  };

 const handleDisponibilizar = async (petParaLiberar) => {
    const alvo = petParaLiberar?.id ? petParaLiberar : petSelecionado;
    
    if (!alvo || !alvo.id) {
      toast.error("Não foi possível identificar o pet para liberação.");
      return;
    }

    toast.warning(
      ({ closeToast }) => (
        <div>
          <span>Deseja liberar o(a) {alvo.nome} para a página de adoção?</span>
          <div style={{ display: "flex", gap: 8, marginTop: 8 }}>
            <button
              onClick={closeToast}
              style={{ background: "#fff", color: "#2e7d32", border: "1px solid #2e7d32", borderRadius: 8, padding: "4px 12px", cursor: "pointer", fontWeight: "bold" }}
            >
              Cancelar
            </button>
            <button
              onClick={async () => {
                closeToast();
                try {
                  await api.put(`/pets/${alvo.id}/disponibilizar`);
                  toast.success("Pet liberado com sucesso! 🐾");
                  fetchPets();
                  if (petSelecionado && petSelecionado.id === alvo.id) {
                    setPetSelecionado(prev => ({ 
                      ...prev, 
                      status: 'DISPONIVEL_ADOCAO',
                      statusAdocao: 'disponivel' 
                    }));
                  }
                } catch (error) {
                  console.error("Erro ao liberar pet:", error);
                  toast.error("Erro ao tentar liberar o pet.");
                }
              }}
              style={{ background: "#2e7d32", color: "#fff", border: "none", borderRadius: 8, padding: "4px 12px", cursor: "pointer", fontWeight: "bold" }}
            >
              Liberar
            </button>
          </div>
        </div>
      ),
      { autoClose: false, closeButton: false }
    );
  };

  useEffect(() => {
    const tiposComRadio = ['Consulta geral', 'Vermifugação', 'Exame clínico'];

    if (!tiposComRadio.includes(novoAtendimento.tipoAtendimento) && novoAtendimento.tomouVacina !== 'nao') {
      setNovoAtendimento((prev) => ({ ...prev, tomouVacina: 'nao' }));
    }
  }, [novoAtendimento.tipoAtendimento, novoAtendimento.tomouVacina]);

 const exportarProntuarioExcel = async () => {
  if (!petSelecionado || historicoFiltrado.length === 0) {
    toast.warning("Não há registros para exportar.");
    return;
  }

  const [excelModule, fileSaverModule] = await Promise.all([
    import("exceljs"),
    import("file-saver"),
  ]);
  const ExcelJS = excelModule.default || excelModule;
  const saveAs = fileSaverModule.saveAs || fileSaverModule.default?.saveAs || fileSaverModule.default;

  const vacinasCadastro = petSelecionado?.vacinas || "Nenhuma informada no cadastro";
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('Prontuário Clínico');

  // 1. Configuração das Colunas (A até J)
  worksheet.columns = [
    { header: 'Dados do Pet', key: 'pet_dados', width: 35, style: { alignment: { wrapText: true, vertical: 'middle', horizontal: 'center' } } },
    { header: 'Origem (ONG/Protetor)', key: 'origem', width: 25, style: { alignment: { vertical: 'middle', horizontal: 'center' } } },
    { header: 'Histórico de Vacinas', key: 'vacinas_info', width: 45, style: { alignment: { wrapText: true, vertical: 'middle', horizontal: 'left' } } },
    { header: 'Castrado', key: 'castrado', width: 12, style: { alignment: { vertical: 'middle', horizontal: 'center' } } },
    { header: 'Microchip', key: 'microchip', width: 12, style: { alignment: { vertical: 'middle', horizontal: 'center' } } },
    { header: 'Data do Atendimento', key: 'data', width: 15, style: { alignment: { vertical: 'middle', horizontal: 'center' } } },
    { header: 'Tipo de Registro', key: 'tipo', width: 25, style: { alignment: { vertical: 'middle', horizontal: 'center' } } },
    { header: 'Descrição do Atendimento', key: 'descricao', width: 50, style: { alignment: { wrapText: true, vertical: 'middle', horizontal: 'left' } } },
    { header: 'Prescrição', key: 'prescricao', width: 40, style: { alignment: { wrapText: true, vertical: 'middle', horizontal: 'left' } } },
    { header: 'Responsável', key: 'responsavel', width: 25, style: { alignment: { vertical: 'middle', horizontal: 'center' } } }
  ];

  // 2. Cabeçalho Superior
  worksheet.insertRow(1, []); 
  worksheet.insertRow(2, []); 
  worksheet.insertRow(3, [`Relatório Clínico de Prontuário - Acolhe Pet SSA`]);
  
  const origemPet = petSelecionado?.ong?.nome || petSelecionado?.protetor?.nome || "Não informado";
  const dataHoraGeracao = new Date().toLocaleString('pt-BR');
  
  worksheet.insertRow(4, [`Pet: ${petSelecionado.nome} | Instituição: ${origemPet} | Registros: ${historicoFiltrado.length} | Gerado em: ${dataHoraGeracao}`]);
  
  worksheet.mergeCells('A3:J3');
  worksheet.getCell('A3').font = { size: 14, bold: true, color: { argb: 'FF2E7D32' } };
  worksheet.getCell('A3').alignment = { vertical: 'middle', horizontal: 'center' };
  worksheet.mergeCells('A4:J4');
  worksheet.getCell('A4').font = { size: 11, bold: true, color: { argb: 'FF555555' } };
  worksheet.getCell('A4').alignment = { vertical: 'middle', horizontal: 'center' };

  worksheet.insertRow(5, []); 

  // 3. Adicionando os Dados
  historicoFiltrado.forEach(item => {
    const petInfo = `NOME: ${petSelecionado.nome}\nIDADE: ${petSelecionado.idade || 'N/I'}\nRAÇA: ${petSelecionado.raca}\nSEXO: ${petSelecionado.sexo}`;

    // Lógica para extrair as vacinas DESTE atendimento
    let vacinasDesteAtendimento = "Nenhuma vacina aplicada neste atendimento";
    let tipoFormatado = item.tipoAtendimento;

    if (item.descricao && item.descricao.includes("Vacinas:")) {
      const partes = item.descricao.split("Vacinas:");
      if (partes.length > 1) {
        vacinasDesteAtendimento = partes[1].split(".")[0].trim();
        
        // REGRA NOVA: Se tem vacina e não é do tipo "Vacina", concatena no Título da coluna Tipo
        if (tipoFormatado !== "Vacina") {
          tipoFormatado = `${tipoFormatado} + Vacina(s)`;
        }
      }
    }

    worksheet.addRow({
      pet_dados: petInfo,
      origem: origemPet,
      vacinas_info: `Vacina(s) no atendimento: ${vacinasDesteAtendimento}\nVacinas apontadas no cadastro do PET: ${vacinasCadastro}`,
      castrado: paraSimNaoLabel(petSelecionado.castrado),
      microchip: paraSimNaoLabel(petSelecionado.microchipado),
      data: dayjs(item.dataAtendimento).format('DD/MM/YYYY'),
      tipo: tipoFormatado, // <--- Aqui vai o Tipo atualizado
      descricao: item.descricao,
      prescricao: item.prescricao || "Sem prescrição registrada",
      responsavel: item.veterinarioResponsavel
    });
  });

  // 4. Estilo do Header da Tabela (Linha 6)
  const headerRow = worksheet.getRow(6);
  headerRow.eachCell((cell) => {
    cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF2E7D32' } };
    cell.font = { color: { argb: 'FFFFFFFF' }, bold: true };
    cell.alignment = { horizontal: 'center', vertical: 'middle' };
    cell.border = { top: {style:'thin'}, left: {style:'thin'}, bottom: {style:'thin'}, right: {style:'thin'} };
  });

  // 5. Logo e Download
  try {
    const response = await fetch('/logo_header_color.png');
    const blob = await response.blob();
    const arrayBuffer = await blob.arrayBuffer();
    const logoId = workbook.addImage({ buffer: arrayBuffer, extension: 'png' });
    worksheet.addImage(logoId, { tl: { col: 0, row: 0 }, ext: { width: 300, height: 85 } });
  } catch (e) { console.error("Erro na logo:", e); }

  const buffer = await workbook.xlsx.writeBuffer();
  saveAs(new Blob([buffer]), `Prontuario_${petSelecionado.nome.replace(/\s/g, '_')}_${dayjs().format('DD_MM_YYYY')}.xlsx`);
  toast.success("Relatório clínico emitido com sucesso! 📊🐾💉");
};

// No handle do Autocomplete de Exames:
const formatarExamesParaPrescricao = (examesSelecionados) => {
  if (examesSelecionados.length === 0) return "";

  const categoriasSangue = ["BIOQUÍMICA", "HEMATOLOGIA", "HEMOSTASIA", "PERFIS", "HORMÔNIOS", "SOROLOGIA"];
  const categoriasOrdenadas = [];
  const examesPorCategoria = new Map();
  let textoSangue = "";

  const formatarCategoria = (categoria) =>
    categoria
      .toLowerCase()
      .replace(/\b\w/g, (letra) => letra.toUpperCase());

  examesSelecionados.forEach((exame) => {
    if (categoriasSangue.includes(exame.categoria)) {
      textoSangue += textoSangue === "" ? exame.nome : `, ${exame.nome}`;
      return;
    }

    if (!examesPorCategoria.has(exame.categoria)) {
      examesPorCategoria.set(exame.categoria, []);
      categoriasOrdenadas.push(exame.categoria);
    }
    examesPorCategoria.get(exame.categoria).push(exame.nome);
  });

  let resultado = "Solicitação de Exames:\n";
  if (textoSangue) resultado += `Sangue / Laboratório:\n ${textoSangue}\n`;

  categoriasOrdenadas.forEach((categoria) => {
    const lista = examesPorCategoria.get(categoria) || [];
    if (lista.length === 0) return;
    resultado += `\n${formatarCategoria(categoria)}:\n`;
    resultado += lista.map((item) => `- ${item}`).join('\n');
    resultado += "\n";
  });

  return resultado.trim();
};

const handleImprimirPrescricao = (item) => {
  const dataAtualFormatada = dayjs().format('DD/MM/YYYY');
  const logoUrl = `${window.location.origin}/logo_header_color.png`;
  const pesoExtraidoDescricao = (item.descricao || '').match(/Peso:\s*([\d.,]+)/i)?.[1] || '---';
  const pesoAtual = item.peso || pesoExtraidoDescricao;
  const ongId = item.ongId || item.ong?.id || item.pet?.ong?.id || petSelecionado?.ongId || petSelecionado?.ong?.id;
  const dadosOng = (ongs || []).find((ong) => String(ong.id) === String(ongId)) || {};
  const ongInfo = item.ong || item.pet?.ong || petSelecionado?.ong || dadosOng || {};
  const enderecoObjeto = ongInfo.endereco && typeof ongInfo.endereco === 'object' ? ongInfo.endereco : {};
  const logradouro = ongInfo.logradouro || ongInfo.rua || enderecoObjeto.logradouro || enderecoObjeto.rua;
  const numero = ongInfo.numero || enderecoObjeto.numero;
  const bairro = ongInfo.bairro || enderecoObjeto.bairro;
  const cidade = ongInfo.cidade || enderecoObjeto.cidade;
  const estado = ongInfo.estado || enderecoObjeto.estado;
  const cep = ongInfo.cep || enderecoObjeto.cep;
  const ruaNumero = [logradouro, numero].filter(Boolean).join(', ');
  const cidadeEstado = [cidade, estado].filter(Boolean).join(' - ');
  const enderecoBase = [ruaNumero, bairro, cidadeEstado].filter(Boolean).join(', ');
  const enderecoCompleto = enderecoBase
    ? `${enderecoBase}${cep ? `. CEP: ${cep}` : ''}`
    : 'Endereço não informado';
  const contatoOng = formatarTelefone(ongInfo.celular || ongInfo.telefone || '');
  
  const descricaoAtendimento = item.descricao || '';
  const deveExibirDescricao = ['Exame clínico', 'Cirurgia / Castração'].includes(item.tipoAtendimento);
  const descricaoJustificativa = (() => {
    if (!descricaoAtendimento) return '';
    const linhas = descricaoAtendimento
      .split('\n')
      .map((linha) => linha.trim())
      .filter(Boolean);

    const linhaDescricao = linhas.find((linha) => /^descrição:/i.test(linha));
    if (linhaDescricao) return linhaDescricao.replace(/^descrição:\s*/i, '');

    return linhas.filter((linha) => !/^peso:/i.test(linha) && !/^vacinas:/i.test(linha)).join('\n');
  })();
  const prescricaoFormatada = (item.prescricao || '').replace(
    /Solicitação de Exames:/gi,
    '<strong>Solicitação de Exames:</strong>'
  );

  const conteudo = `
    <html>
      <head>
        <title>Prescrição Médica - Acolhe Pet SSA</title>
        <style>
          body {
            font-family: Arial, sans-serif;
            padding: 34px;
            line-height: 1.5;
            color: #1f1f1f;
            background-color: #ffffff;
            background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='120' height='120' viewBox='0 0 120 120'><g fill='%23d9d9d9' fill-opacity='0.28'><circle cx='35' cy='28' r='6'/><circle cx='55' cy='20' r='6'/><circle cx='75' cy='28' r='6'/><circle cx='50' cy='60' r='10'/><ellipse cx='65' cy='65' rx='12' ry='9'/></g></svg>");
            background-repeat: repeat;
            background-size: 120px 120px;
          }
          .top-logo { margin-bottom: 8px; }
          .logo { width: 240px; height: auto; }
          .titulo { text-align: center; font-size: 18px; font-weight: 500; margin: 8px 0 18px 0; }
          .intro { font-size: 13px; text-align: justify; margin-bottom: 14px; }
          .linha { border-top: 1px solid #d9d9d9; margin: 10px 0 14px 0; }
          .bloco-pet { font-size: 13px; margin-bottom: 16px; }
          .bloco-pet p { margin: 4px 0; }
          .bloco-ong { font-size: 13px; margin-bottom: 16px; }
          .bloco-ong p { margin: 4px 0; }
          .subtitulo { font-size: 14px; font-weight: 700; margin: 12px 0 8px 0; }
          .prescricao { min-height: 220px; border: 1px solid #e0e0e0; border-radius: 6px; padding: 4px 12px 12px; white-space: pre-line; font-size: 13px; }
          .rodape-local { margin-top: 28px; text-align: right; font-size: 13px; }
          .assinatura-box { margin-top: 58px; text-align: center; }
          .assinatura-linha { border-top: 1px solid #000; width: 280px; margin: 0 auto 8px auto; }
          .assinatura-nome { margin: 0; font-weight: 400; font-size: 12px; }
          .assinatura-cargo { margin: 2px 0 0 0; font-size: 12px; }

          @media print {
            body { padding: 22px; }
          }
        </style>
      </head>
      <body>
        <div class="top-logo">
          <img class="logo" src="${logoUrl}" alt="Logo Acolhe Pet SSA" />
        </div>

        <div class="titulo">GUIA DE ENCAMINHAMENTO / RECEITUÁRIO</div>

        <div class="linha"></div>

        <div class="bloco-pet">
          <p><strong>PET:</strong> ${(petSelecionado.nome || '').toUpperCase()}</p>
          <p><strong>Espécie:</strong> ${petSelecionado.tipo || 'Não informada'} | <strong>Raça:</strong> ${petSelecionado.raca || 'Não informada'} | <strong>Peso atual:</strong> ${pesoAtual} kg</p>
          <p><strong>Tipo de atendimento:</strong> ${item.tipoAtendimento || 'Não informado'} | <strong>Data do atendimento:</strong> ${dayjs(item.dataAtendimento).format('DD/MM/YYYY')}</p>
        </div>

        <div class="bloco-ong">
          <p><strong>ONG / Protetor Responsável:</strong> ${item.ongNome || item.ong?.nome || ongInfo.nome || dadosOng.nome || 'Não informado'}</p>
          <p><strong>Endereço:</strong> ${enderecoCompleto}</p>
          <p><strong>Contato:</strong> ${contatoOng || 'Não informado'}</p>
        </div>

        <div class="linha"></div>

        <div class="subtitulo">Prescrição / Encaminhamento</div>

        <div class="prescricao">
          ${deveExibirDescricao ? `<strong>Descrição:</strong> ${descricaoJustificativa || 'Sem justificativa registrada.'}\n` : ''}
          ${prescricaoFormatada || 'Nenhuma prescrição registrada.'}
        </div>

        <div class="rodape-local">
          Salvador - BA, ${dataAtualFormatada}
        </div>

        <div class="assinatura-box">
          <div class="assinatura-linha"></div>
          <p class="assinatura-nome">${item.veterinarioResponsavel}</p>
        </div>
      </body>
    </html>
  `;

  imprimirHtml(conteudo);
};

  return (
    <Container maxWidth="lg" sx={{ py: 6 }}>
      {loading && (
        <Box
          sx={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            bgcolor: 'rgba(255,255,255,0.7)',
            zIndex: 9999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <Box component="img" src="/logo_com_nome_reduzida.png" alt="Logo Acolhe Pet SSA" sx={{ width: 80, mb: 2 }} />
            <CircularProgress size={48} color="success" />
            <Typography variant="h6" sx={{ mt: 2, color: '#2e7d32', fontWeight: 'bold' }}>
              Carregando pets...
            </Typography>
          </Box>
        </Box>
      )}

      <Card sx={{ borderRadius: 4, boxShadow: "0px 8px 24px rgba(0,0,0,0.06)", p: { xs: 2, md: 4 } }}>
        <Typography variant="h5" align="center" sx={{ fontWeight: "bold", color: "#2e7d32", mb: 1 }}>Gestão clínica e prontuários</Typography>
        <Typography variant="body1" align="center" color="textSecondary" sx={{ mb: 4 }}>Histórico médico e acompanhamento de saúde.</Typography>

        {/* <Box sx={{ mb: 3, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <TextField
            size="small"
            placeholder="Buscar pet..."
            onChange={(e) => { setFiltroNome(e.target.value); setPagina(1); }}
            InputProps={{ startAdornment: <SearchIcon sx={{ color: 'text.secondary', mr: 1 }} /> }}
            sx={{ width: 300, '& .MuiOutlinedInput-root': { borderRadius: 3 } }}
          />
          <Chip label={`Total: ${pets.length} pets`} sx={{ fontWeight: 'bold', bgcolor: '#e8f5e9', color: '#2e7d32' }} />
        </Box> */}


<Box sx={{ mb: 3, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2 }}>
  <TextField
    size="small"
    placeholder="Buscar pet..."
    onChange={(e) => { setFiltroNome(e.target.value); setPagina(1); }}
    InputProps={{ startAdornment: <SearchIcon sx={{ color: 'text.secondary', mr: 1 }} /> }}
    sx={{ width: 300, '& .MuiOutlinedInput-root': { borderRadius: 3 } }}
  />
  
  {/* Stack organizado contendo os indicadores estilizados em Chips */}
  <Box sx={{ display: 'flex', gap: 1.5, alignItems: 'center', flexWrap: 'wrap' }}>
    <Chip 
      label={`Total: ${totalPetsGeral} ${totalPetsGeral === 1 ? 'pet' : 'pets'}`} 
      sx={{ fontWeight: 'bold', borderColor: '#1976d2', bgcolor: '#E8F1FC', color: '#1976d2' }} 
    />
    
    <Chip 
      label={`Em quarentena: ${totalEmQuarentena}`} 
      sx={{ 
        fontWeight: 'bold', 
        bgcolor: '#fff3e0', 
        color: '#ef6c00',
        border: '1px solid #ffb74d'
      }} 
    />
    
    <Chip 
      label={`Liberados: ${totalLiberados}`} 
      sx={{ 
        fontWeight: 'bold', 
        bgcolor: '#e8f5e9', 
        color: '#2e7d32',
        border: '1px solid #81c784'
      }} 
    />
  </Box>
</Box>

        <TableContainer component={Paper} elevation={0} sx={{ borderRadius: 3, mb: 2, border: '2px solid #e8f5e9' }}>
          <Table size="small">
            <TableHead sx={{ bgcolor: "#e8f5e9" }}>
              <TableRow>
                <TableCell sx={{ fontWeight: 'bold', color: '#2e7d32' }}>Pet</TableCell>
                <TableCell sx={{ fontWeight: 'bold', color: '#2e7d32' }}>Status</TableCell>
                <TableCell align="center" sx={{ fontWeight: 'bold', color: '#2e7d32' }}>Ação</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {petsExibidos.map((pet) => (
                <TableRow key={pet.id} hover selected={petSelecionado?.id === pet.id}>
                  <TableCell>
                    <Typography variant="body2" sx={{ fontWeight: 'bold' }}>{pet.nome}</Typography>
                    <Typography variant="caption" color="textSecondary">{pet.tipo} • {pet.raca} • {pet.idade}</Typography>
                  </TableCell>
                  <TableCell>
                    <Chip label={(pet.status || 'ACOLHIDO') === 'ACOLHIDO' ? 'Em quarentena' : 'Liberado'} size="small" 
                          sx={{ bgcolor: (pet.status || 'ACOLHIDO') === 'ACOLHIDO' ? '#fff3e0' : '#c8e6c9', color: (pet.status || 'ACOLHIDO') === 'ACOLHIDO' ? '#ef6c00' : '#2e7d32', fontWeight: 'bold' }} />
                  </TableCell>
                  <TableCell align="center">
                    <Button variant="outlined" color="primary" size="small" startIcon={<MedicalInformationIcon />} onClick={() => setPetSelecionado(pet)}
                           sx={{ 
                        textTransform: 'none', 
                        borderRadius: '10px', 
                        fontWeight: 'bold', 
                        fontSize: '0.75rem',
                        '&:hover': { borderColor: '#1976d2', bgcolor: '#E8F1FC' }
                      }}
>
                      {apenasLeituraProntuario ? 'Visualizar Atendimentos' : 'Atender'}
                    </Button>
                 {podeEditarProntuario && (pet.status || 'ACOLHIDO') === 'ACOLHIDO' && (
      <Button
        variant="outlined"
        size="small"
        startIcon={<CheckBoxIcon />}
        onClick={() => handleDisponibilizar(pet)}
        sx={{
          color: '#2e7d32',
          ml: 2,
          borderColor: '#2e7d32',
          textTransform: 'none',
          borderRadius: '10px',
          fontWeight: 'bold',
          fontSize: '0.75rem',
          '&:hover': { 
            borderColor: '#1b5e20', 
            bgcolor: '#f1f8e9',
            borderWidth: '1px'
          }
        }}
      >
        Liberar
      </Button>
      )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 4 }}><Pagination count={totalPaginas} page={pagina} onChange={(_, v) => setPagina(v)} color="success" size="small" shape="rounded" /></Box>

        {petSelecionado && (
          <Fade in={true}>
            <Box sx={{ mt: 4, p: { xs: 2, md: 4 }, bgcolor: "#fcfdfc", borderRadius: 4, border: "1px solid #edf2ed" }}>
              {apenasLeituraProntuario && (
                <Card sx={{ mb: 4, borderRadius: 3, boxShadow: "0px 4px 20px rgba(0,0,0,0.05)" }}>
                  <CardContent sx={{ p: 3 }}>
                    <Grid container spacing={3} alignItems="center">
                      <Grid><Avatar src={petSelecionado.fotoUrl} variant="rounded" sx={{ width: 80, height: 80, borderRadius: 3, boxShadow: 2 }} /></Grid>
                      <Grid size="grow">
                        <Typography variant="h5" sx={{ fontWeight: 'bold', color: '#2e7d32' }}>{petSelecionado.nome}</Typography>
                        <Typography variant="body2" color="textSecondary">{petSelecionado.tipo} • {petSelecionado.raca} • {petSelecionado.idade || 'Idade n/i'}</Typography>
                      </Grid>
                    </Grid>
                    {podeEditarProntuario && (petSelecionado.status || 'ACOLHIDO') === 'ACOLHIDO' && (
                      <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
                        <Button
  variant="contained"
  color="success"
  onClick={() => handleDisponibilizar(petSelecionado)} // Aqui passa o pet do card
  sx={{ borderRadius: '20px', textTransform: 'none', fontWeight: 'bold' }}
>
  Liberar para adoção
</Button>
                      </Box>
                    )}
                  </CardContent>
                </Card>
              )}

              <Grid container spacing={4} alignItems="flex-start">
                {!apenasLeituraProntuario && (
                  <>
                    <Grid size={{ xs: 12, md: 7 }}>
                      <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 2, ml: 1 }}>
                        Novo registro médico
                      </Typography>
                      <Card sx={{ borderRadius: 3, boxShadow: "0px 8px 24px rgba(46, 125, 50, 0.08)" }}>
                        <CardContent sx={{ p: 3 }}>
                          <Box component="form" onSubmit={handleSalvarAtendimento} sx={{ display: 'flex', flexDirection: 'column' }}>
                            <Box>
                              <TextField
                            select
                            fullWidth
                            label="Tipo de atendimento"
                            value={novoAtendimento.tipoAtendimento}
                            sx={{ mb: 2, mt: 1, ...campoPreenchidoSx(novoAtendimento.tipoAtendimento !== '') }}
                            required
                            onChange={(e) => setNovoAtendimento({ ...novoAtendimento, tipoAtendimento: e.target.value })}
                          >
                            <MenuItem value="Consulta geral">Consulta geral</MenuItem>
                            <MenuItem value="Vacinação">Vacinação</MenuItem>
                            <MenuItem value="Vermifugação">Vermifugação</MenuItem>
                            <MenuItem value="Exame clínico">Exame clínico</MenuItem>
                            <MenuItem value="Cirurgia / Castração">Cirurgia / Castração</MenuItem>
                          </TextField>

                              <TextField
                                fullWidth
                                label="Peso do pet (kg)"
                                value={novoAtendimento.peso}
                                required
                                sx={{ mb: 2, ...campoPreenchidoSx(novoAtendimento.peso.trim() !== '') }}
                                placeholder="Ex.: 2.5"
                                helperText="Use ponto. Ex.: 2.5"
                                onChange={(e) =>
                                  setNovoAtendimento({ ...novoAtendimento, peso: formatarPesoInput(e.target.value) })
                                }
                                onBlur={() =>
                                  setNovoAtendimento((prev) => ({
                                    ...prev,
                                    peso: formatarPesoFinal(prev.peso),
                                  }))
                                }
                              />

                      

                              <Box sx={{ mb: 2, minHeight: 56 }}>
                              
                               {/* RADIO BUTTON CONDICIONAL: Apenas para Consulta, Vermifugação e Exame */}
                                  {['Consulta geral', 'Vermifugação', 'Exame clínico'].includes(novoAtendimento.tipoAtendimento) && (
                                    <Fade in={true}>
                                     <Box sx={{ mb: 2, p: 1.5, borderRadius: 2, bgcolor: '#f9fff9', border: '1px dashed #2e7d32' }}>
                                <Typography sx={{ fontSize: '0.85rem', color: '#2e7d32', fontWeight: 'bold', mb: 1 }}>
                                  Houve aplicação de vacina neste atendimento?
                                </Typography>
                                <RadioGroup
                                  row
                                  value={novoAtendimento.tomouVacina}
                                  onChange={(e) => setNovoAtendimento({ ...novoAtendimento, tomouVacina: e.target.value })}
                                >
                                  <FormControlLabel value="nao" control={<Radio color="success" size="small" />} label="Não" />
                                  <FormControlLabel value="sim" control={<Radio color="success" size="small" />} label="Sim" />
                                </RadioGroup>
                              </Box>
                                    </Fade>
                                  )}

                                
                               {/* SELETOR DE VACINAS */}
                          {(novoAtendimento.tipoAtendimento === 'Vacinação' || novoAtendimento.tomouVacina === 'sim') && (
                            <Fade in={true}>
                              <Box sx={{ mb: 2 }}>
                                <Autocomplete
                                  multiple
                                  disableCloseOnSelect
                                  options={listaVacinasDisponiveis}
                                  value={novoAtendimento.vacinasAplicadas}
                                  onChange={(_, newValue) => setNovoAtendimento({ ...novoAtendimento, vacinasAplicadas: newValue })}
                                  renderOption={(props, option, { selected }) => {
                                    const { key, ...optionProps } = props;

                                    return (
                                      <li key={key} {...optionProps}>
                                        <Checkbox icon={icon} checkedIcon={checkedIcon} checked={selected} color="success" style={{ marginRight: 8 }} />
                                        {option}
                                      </li>
                                    );
                                  }}
                                  renderTags={(tagValue, getTagProps) =>
                                    tagValue.map((option, index) => {
                                      const { key, ...tagProps } = getTagProps({ index });

                                      return (
                                        <Chip
                                          key={key}
                                          label={option}
                                          {...tagProps}
                                          size="small"
                                          sx={{ bgcolor: '#e8f5e9', color: '#2e7d32', fontWeight: 'bold' }}
                                        />
                                      );
                                    })
                                  }
                                  renderInput={(params) => <TextField {...params} label="Vacinas aplicadas" />}
                                />
                              </Box>
                            </Fade>
                          )}

                          {/* SELETOR DE EXAMES (Aparece apenas quando o tipo é Exame clínico) */}
{novoAtendimento.tipoAtendimento === 'Exame clínico' && (
  <Fade in={true}>
    <Box sx={{ mb: 2 }}>
      <Autocomplete
        multiple
        disableCloseOnSelect
        options={listaExamesDisponiveis}
        groupBy={(option) => option.categoria}
        getOptionLabel={(option) => option.nome}
        isOptionEqualToValue={(option, value) => option.nome === value.nome && option.categoria === value.categoria}
        value={novoAtendimento.examesSelecionados || []}
        onChange={(_, newValue) => {
          const textoExamesFormatados = formatarExamesParaPrescricao(newValue);
          setNovoAtendimento((prev) => ({
            ...prev,
            examesSelecionados: newValue,
           
            prescricao: textoExamesFormatados 
          }));
        }}
        renderOption={(props, option, { selected }) => {
          const { key, ...optionProps } = props;

          return (
            <li key={key} {...optionProps}>
              <Checkbox
                icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                checkedIcon={<CheckBoxIcon fontSize="small" />}
                style={{ marginRight: 8 }}
                checked={selected}
                color="primary"
              />
              {option.nome}
            </li>
          );
        }}
        renderTags={(tagValue, getTagProps) =>
          tagValue.map((option, index) => {
            const { key, ...tagProps } = getTagProps({ index });

            return (
              <Chip
                key={key}
                label={option.nome}
                {...tagProps}
                size="small"
                sx={{ 
                  bgcolor: '#e3f2fd', 
                  color: '#1976d2', 
                  fontWeight: 'bold',
                  border: '1px solid #bbdefb' 
                }}
              />
            );
          })
        }
        renderInput={(params) => (
          <TextField
            {...params}
            label="Solicitar Exames"
            placeholder="Selecione os exames..."
            variant="outlined"
            helperText="Os exames selecionados serão adicionados automaticamente à prescrição."
            FormHelperTextProps={{ sx: { color: '#1976d2', fontWeight: 'bold' } }}
          />
        )}
      />
    </Box>
  </Fade>
)}
                              </Box>

                              <TextField
                                fullWidth
                                label="Descrição do atendimento"
                                multiline
                                rows={3}
                                value={novoAtendimento.descricao}
                                sx={{ mb: 2, ...campoPreenchidoSx(novoAtendimento.descricao.trim() !== '') }}
                                required
                                placeholder="Detalhes clínicos..."
                                inputProps={{ maxLength: LIMITE_DESCRICAO }}
                                helperText={`${novoAtendimento.descricao.length}/${LIMITE_DESCRICAO}`}
                                onChange={(e) => setNovoAtendimento({ ...novoAtendimento, descricao: e.target.value })}
                              />

                              <TextField
                                fullWidth
                                label="Prescrição"
                                multiline
                                rows={4}
                                value={novoAtendimento.prescricao}
                                sx={{ mb: 3, ...campoPreenchidoSx(novoAtendimento.prescricao.trim() !== '') }}
                                placeholder="Medicamentos ou orientações prescritas"
                                inputProps={{ maxLength: LIMITE_PRESCRICAO }}
                                helperText={`${novoAtendimento.prescricao.length}/${LIMITE_PRESCRICAO}`}
                                onChange={(e) => setNovoAtendimento({ ...novoAtendimento, prescricao: e.target.value })}
                              />
                            </Box>

                            <Button
                              fullWidth
                              variant="contained"
                              color="success"
                              type="submit"
                              disabled={salvando || !formObrigatorioPreenchido}
                              startIcon={!salvando && <SaveIcon />}
                              sx={{ borderRadius: '12px', py: 1.5, fontWeight: 'bold', textTransform: 'none', bgcolor: '#2e7d32' }}
                            >
                              {salvando ? <CircularProgress size={24} color="inherit" /> : 'Salvar atendimento'}
                            </Button>
                          </Box>
                        </CardContent>
                      </Card>
                    </Grid>

                    <Grid size={{ xs: 12, md: 5 }}>
                      <Card sx={{ borderRadius: 3, boxShadow: "0px 4px 20px rgba(0,0,0,0.05)", height: '100%',mt: 5.5 }}>
                        <CardContent sx={{ p: 3 }}>
                          <Grid container spacing={3} alignItems="center">
                            <Grid><Avatar src={petSelecionado.fotoUrl} variant="rounded" sx={{ width: 80, height: 80, borderRadius: 3, boxShadow: 2 }} /></Grid>
                            <Grid size="grow">
                              <Typography variant="h5" sx={{ fontWeight: 'bold', color: '#2e7d32' }}>{petSelecionado.nome}</Typography>
                              <Typography variant="body2" color="textSecondary">{petSelecionado.tipo} • {petSelecionado.raca} • {petSelecionado.idade || 'Idade n/i'}</Typography>
                              {detalhesCardPetPrincipais.length > 0 && (
                                <Box sx={{ mt: 1.5, display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                                  {detalhesCardPetPrincipais.map((item) => (
                                    <Chip
                                      key={item.label}
                                      size="small"
                                      label={`${item.label}: ${item.valor}`}
                                      sx={{ bgcolor: '#f3f7f3', color: '#2e7d32', fontWeight: 600 }}
                                    />
                                  ))}
                                </Box>
                              )}
                              {detalheUltimoAtendimento && (
                                <Box sx={{ mt: 1 }}>
                                  <Chip
                                    size="small"
                                    label={`${detalheUltimoAtendimento.label}: ${detalheUltimoAtendimento.valor}`}
                                    sx={{ bgcolor: '#f3f7f3', color: '#2e7d32', fontWeight: 600 }}
                                  />
                                </Box>
                              )}
                              {podeEditarProntuario && (petSelecionado.status || 'ACOLHIDO') === 'ACOLHIDO' && (
                                <Box sx={{ mt: 2, display: 'flex' }}>
                                  <Button
                                    variant="contained"
                                    color="success"
                                    onClick={handleDisponibilizar}
                                    sx={{ borderRadius: '20px', textTransform: 'none', fontWeight: 'bold' }}
                                  >
                                    Liberar para adoção
                                  </Button>
                                </Box>
                              )}
                            </Grid>
                          </Grid>
                        </CardContent>
                      </Card>
                    </Grid>
                  </>
                )}

                <Grid size={12}>
                  <Paper sx={{ p: 3, borderRadius: 3, border: '1px solid #f0f0f0' }}>
                  <Typography variant="subtitle1" ref={timelineRef} sx={{ fontWeight: 'bold', mb: 2 }}>
                    Linha do tempo clínica
                  </Typography>
                  {apenasLeituraProntuario && (
                    <Alert severity="info" sx={{ mb: 2 }}>
                      Cadastrador pode apenas visualizar a linha do tempo dos atendimentos.
                    </Alert>
                  )}
                  <Typography variant="subtitle2" sx={{ mb: 1}}>
                    Filtrar por:
                  </Typography>

<Box sx={{ mb: 4 }}>
  <Stack 
    direction="row" 
    spacing={2} 
    useFlexGap 
    flexWrap="wrap" 
    alignItems="center"
  >
    {/* Filtro por Tipo */}
   <TextField
  select
  size="small"
  label="Tipo de atendimento"
  value={filtroTipoTimeline}
  onChange={(e) => setFiltroTipoTimeline(e.target.value)}
  sx={{ minWidth: 200, '& .MuiOutlinedInput-root': { borderRadius: 3 } }}
>
  <MenuItem value="">Todos os registros</MenuItem>
  <MenuItem value="Consulta geral">Consulta geral</MenuItem>
  <MenuItem value="Vacinação">Vacinação</MenuItem>
  <MenuItem value="Vermifugação">Vermifugação</MenuItem>
  <MenuItem value="Exame clínico">Exame clínico</MenuItem>
  <MenuItem value="Cirurgia / Castração">Cirurgia / Castração</MenuItem>
</TextField>

  <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
      <DatePicker
        label="Mês/Ano"
        views={['month', 'year']} 
        open={openDatePicker}
        onOpen={() => setOpenDatePicker(true)}
        onClose={() => setOpenDatePicker(false)}
        value={filtroMesAnoTimeline ? dayjs(filtroMesAnoTimeline) : null}
        
        onChange={(newValue) => {
          setFiltroMesAnoTimeline(newValue ? newValue.format('YYYY-MM') : '');
          setOpenDatePicker(false);
        }}

        slotProps={{
          textField: {
            size: 'small',
            onClick: () => setOpenDatePicker(true), 
            sx: { 
              minWidth: 180,
              borderRadius: 12, 
              '& .MuiOutlinedInput-root': { borderRadius: 12 } 
            }
          }
        }}
      />
    </LocalizationProvider>
    
    {(filtroTipoTimeline || filtroMesAnoTimeline) && (
      <Button
        variant="outlined"
        color="success"
        onClick={() => {
          setFiltroTipoTimeline('');
          setFiltroMesAnoTimeline('');
        }}
        sx={{ 
          textTransform: 'none', 
          fontWeight: 'bold',
          borderRadius: '10px', 
          '&:hover': { backgroundColor: 'rgba(211, 47, 47, 0.04)' }
        }}
      >
        Limpar filtros
      </Button>
    )}
        <Button
          variant="outlined"
          color="secondary"
          onClick={exportarProntuarioExcel}
          startIcon={<span>📊</span>} 
            sx={{ 
              height: '38px', 
              textTransform: 'none', 
              fontWeight: 'bold', 
              borderRadius: '8px',
              color: '#1976d2', 
              borderColor: '#1976d2',
              backgroundColor: '#ffffff',
              '&:hover': { borderColor: '#1565c0', backgroundColor: '#e3f2fd' } 
            }}
        >
          Exportar Relatório de Atendimentos
        </Button>
      </Stack>
    </Box>
                  <Box
                    sx={{
                      maxHeight: { xs: '460px', md: apenasLeituraProntuario ? '640px' : '520px' },
                      overflowY: 'auto',
                      overflowX: 'hidden',
                      pr: 1,
                    }}
                  >
                    {historicoFiltrado.length === 0 ? (
                      <Alert severity="info">Nenhum atendimento encontrado com os filtros selecionados.</Alert>
                    ) : (
                      historicoFiltrado.map((item, i) => (
                        <Box key={i} sx={{ position: 'relative', pb: 3, pl: 3, borderLeft: '2px solid #e8f5e9', ml: 1 }}>
                          <Box sx={{ position: 'absolute', left: -9, top: 0, width: 16, height: 16, borderRadius: '50%', bgcolor: '#2e7d32', border: '4px solid #fff', boxShadow: 1 }} />
                          <Paper sx={{ p: 3, borderRadius: 3, border: '1px solid #f0f0f0' }}>
                            <Box display="flex" justifyContent="space-between" mb={1}>
  <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#2e7d32', bgcolor: '#e8f5e9', px: 1, borderRadius: 1 }}>
    {item.tipoAtendimento}
  </Typography>
  <Typography variant="caption" sx={{ fontWeight: 'bold', color: '#999' }}>
    {dayjs(item.dataAtendimento).format('DD/MM/YYYY')}
  </Typography>
</Box>

<Typography 
  variant="body2" 
  sx={{ color: '#444', mb: 1, whiteSpace: 'pre-line' }}
>
  {item.descricao.split('Vacinas:').map((texto, index, array) => (
    index === 0 ? (
      <Box key={index} component="span" sx={{ display: 'block' }}>
        {texto.split('\n').map((linha, linhaIndex) => {
          const linhaTratada = linha.trim();

          if (!linhaTratada) return null;

          if (linhaTratada.startsWith('Peso:')) {
            return (
              <span key={`${index}-peso-${linhaIndex}`}>
                <strong>Peso: </strong>{linhaTratada.replace(/^Peso:\s*/, '')}
                <br />
              </span>
            );
          }

          if (linhaTratada.startsWith('Descrição:')) {
            return (
              <span key={`${index}-desc-${linhaIndex}`}>
                <strong>Descrição: </strong>{linhaTratada.replace(/^Descrição:\s*/, '')}
                <br />
              </span>
            );
          }

          return (
            <span key={`${index}-linha-${linhaIndex}`}>
              {linhaTratada}
              <br />
            </span>
          );
        })}
      </Box>
    ) : (
    
      <span key={index}>
       <strong>Vacinas: </strong>{texto}
      </span>
    )
  ))}
</Typography>
                            {item.prescricao && (
                              <Box sx={{ mt: 1, p: 1.5, bgcolor: '#f8fbff', borderRadius: 2, border: '1px solid #e1f0ff' }}>
                                <Typography variant="caption" display="block">
                                  <strong>📋 Prescrição:</strong> {item.prescricao}
                                </Typography>
                              </Box>
                            )}
                            <Box display="flex" justifyContent="space-between" alignItems="center" mt={2}>
                              <Button
                                size="small"
                                startIcon={<span>🖨️</span>}
                                onClick={() => handleImprimirPrescricao(item)}
                                sx={{ textTransform: 'none', color: '#1976d2' }}
                              >
                                Imprimir Guia/Receita
                              </Button>

                              <Typography variant="caption" sx={{ fontStyle: 'italic', color: '#2e7d32' }}>
                                <strong>Por: {item.veterinarioResponsavel}</strong>
                              </Typography>
                            </Box>
                          </Paper>
                        </Box>
                      ))
                    )}
                  </Box>
                  </Paper>  
                </Grid>
              </Grid>
            </Box>
          </Fade>
        )}
      </Card>
    </Container>
  );
};

export default ProntuarioPage;